import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../../../services/http/interceptors/GlobalInterciptor";
import timer from "../Umrahslider/timerr.png";
import date from "../Umrahslider/date.png";
import seat from "../Umrahslider/seat.png";
import umrah from "./umrah_camp_photo_(1)[1].png";
import inter from "./international_camp_photo[1].png";
import canada from "./Canada Camps[1].png"
const ListCamps = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Extract `type` from query parameters
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type") || "Umrah"; // Default to "Umrah"

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`/api/mobile/events?type=${type}`);
        setPosts(response.data?.data?.data || []);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [type]);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5 text-danger">Error: {error}</div>;

  return (
    <div className="container-expand">
      {/* Hero Section */}
      <div className="text-center position-relative mb-5">
        {posts.length > 0 && (
          <>
            <img
              src={type === "Umrah" ? (umrah) : (type === "International Camps" ? inter : canada)}
              alt={posts[0]?.title_en || `${type} Camp`}

              className="w-100 img"
              style={{ height: "300px", width: "1440px", objectFit: "cover" }}
            />
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{ backgroundColor: "rgba(20, 178, 189, 0.8)" }}
            ></div>
            <div
              className="text-white position-absolute text-center w-100 "
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            >
              {type === "Umrah" ? (
                <h1 className="fw-bold">Umrah Camps</h1>
              ) : type === "Canada camps" ? (
                <h1 className="fw-bold">Canada Camps</h1>
              ) : (
                <h1 className="fw-bold">International Camps</h1>
              )}


              <span className="fs-6 fw-normal">Home - {type} </span>
            </div>
          </>
        )}
      </div>

      {/* Section Title */}
      {/* {type==="Umrah"?<div className="container text-center mb-4">
    
    <h1 style={{ color: "rgba(19, 178, 188, 1)" }}>

    Our Umrah Camps
    </h1>
    <p className="text-muted fs-6 px-3 mb-5 mt-4">
    Our Umrah Camps offer a unique and enriching experience for those seeking to embark on the sacred pilgrimage to Makkah and Madinah.
    </p>
  </div>: <div className="container text-center mb-4">
    
    <h1 className="" style={{ color: "rgba(19, 178, 188, 1)" }}>

    Embark on a Global Adventure with Our International Camps
    </h1>
    <p className="text-muted fs-6 px-3 mb-5 mt-4">
    Prepare to be transported beyond borders and immerse yourself in a world of extraordinary experiences. Our International Camps<br></br> offer a unique opportunity to explore diverse cultures.
    </p>
  </div>} */}
      {type === "Umrah" ? (
        <div className="container text-center mb-4">
          <h1 style={{ color: "rgba(19, 178, 188, 1)" }}>
            Our Umrah Camps
          </h1>
          <p className="text-muted fs-6 px-3 mb-5 mt-4">
            Our Umrah Camps offer a unique and enriching experience for those seeking to embark on the sacred pilgrimage to Makkah and Madinah.
          </p>
        </div>
      ) : type === "International Camps" ? (

        <div className="container text-center mb-4">
          <h1 style={{ color: "rgba(19, 178, 188, 1)" }}>
            Embark on a Global Adventure with Our International Camps
          </h1>
          <p className="text-muted fs-6 px-3 mb-5 mt-4">
            Prepare to be transported beyond borders and immerse yourself in a world of extraordinary experiences. Our International Camps<br /> offer a unique opportunity to explore diverse cultures.
          </p>
        </div>
      ) : (
        <div className="container text-center mb-4">
          <h1 style={{ color: "rgba(19, 178, 188, 1)" }}>
            Discover the Magic of Canada with Our Specialized Camps
          </h1>
          <p className="text-muted fs-6 px-3 mb-5 mt-4">
            Dive into the natural beauty of Canada while engaging in cultural and educational adventures. Our Canada Camps provide an unforgettable journey through scenic landscapes and vibrant cities.
          </p>
        </div>
      )}


      {/* Camp Cards */}
      {/* <div className="container mb-5">
        <div className="row g-4">
          {posts.map((post) => (
            <div className="col-12 col-sm-8 col-md-3" key={post.id}>
              <div
                className="card border-0 rounded shadow-sm h-100 position-relative"
                onClick={() =>
                  navigate(`/UmrahDetails/${post.id}`, { state: { type, price: post.price } })
                }
                style={{ cursor: "pointer" }}
              >
   
                {post.remaining_seats < 1 && (
                  <badge
                    className="position-absolute top-0 end-0 badge bg-danger text-white"
                    style={{ padding: "8px 12px", fontSize: "0.9rem", borderRadius: "5px" }}
                  >
                    Not Available
                  </badge>
                )}

                <img
                  src={post.image || "https://via.placeholder.com/300x200"}
                  alt={post.title || `${type} Program`}
                  className="card-img-top rounded-5 border-0 mt-3 img-fluid"
                  style={{
                    maxWidth: "296px",
                    height: "167px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                <div className="card-body ">
                  <h5 className="card-title fw-semibold" style={{ color: "rgba(47, 84, 102, 1)" }}>{post.title || "No Title Available"}</h5>
                  <p className="card-text fw-bold py-1 " style={{ color: "rgba(237, 88, 89, 1)" }}>${post.price || "free"}</p>

       
                  <div className="d-flex align-items-center mb-3">
                    <img src={timer} style={{ width: "20px" }} alt="Timer" />
                    <span className="ms-2 mt-1">{post.period || 0} Days</span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <img src={date} style={{ width: "20px" }} alt="Date" />
                    <span className="ms-2">Availability: {post.date_interval || "No Date"}</span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <img src={seat} style={{ width: "20px" }} alt="Seats" />
                    <span className="ms-2">
                      Available Seats:{" "}
                      {post.remaining_seats > 0 ? (
                        <span style={{ color: "black" }}>{post.remaining_seats}</span>
                      ) : (
                        <span style={{ color: "rgba(237, 88, 89, 1)", fontWeight: "bold" }}>Fully Booked</span>
                      )}
                    </span>
                  </div>


                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="container mb-5">
        <div className="row g-4 ">
          {posts.map((post) => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={post.id}>
              <div
                className="card border-0 rounded shadow-sm h-100 position-relative"
                onClick={() =>
                  navigate(`/UmrahDetails/${post.id}`, { state: { type, price: post.price } })
                }
                style={{ cursor: "pointer" }}
              >
                {/* Badge for Not Available */}
                {post.remaining_seats < 1 && (
                  <span
                    className="position-absolute top-0 end-0 bg-danger text-white"
                    style={{
                      padding: "8px 12px",
                      fontSize: "0.8rem",
                      borderRadius: "0 0 0 10px",
                      zIndex: 1,
                    }}
                  >
                    Not Available
                  </span>
                )}

                <img
                  src={post.image || "https://via.placeholder.com/300x200"}
                  alt={post.title || `${type} Program`}
                  className="card-img-top rounded-3 border-0 mt-3  d-block mx-auto"
                  style={{
                    height: "95px",
                    width: "280",
                    maxWidth: "296px",
                    objectFit: "cover",
                  }}
                />


                <div className="card-body">
                  <h5 className="card-title fw-semibold  text-md-start text-center " style={{ color: "rgba(47, 84, 102, 1)" }}>
                    {post.title || "No Title Available"}
                  </h5>
                  <p className="card-text fw-bold py-1 text-md-start text-center" style={{ color: "rgba(237, 88, 89, 1)" }}>
                    ${post.price || "free"}
                  </p>

                  {/* Details */}
                  <div className="d-flex align-items-center mb-3">
                    <img src={timer} style={{ width: "20px" }} alt="Timer" />
                    <span className="ms-2 mt-1">{post.period || 0} Days</span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <img src={date} style={{ width: "20px" }} alt="Date" />
                    <span className="ms-2">Availability: {post.date_interval || "No Date"}</span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <img src={seat} style={{ width: "20px" }} alt="Seats" />
                    <span className="ms-2">
                      Available Seats:{" "}
                      {post.remaining_seats > 0 ? (
                        <span style={{ color: "black" }}>{post.remaining_seats}</span>
                      ) : (
                        <span style={{ color: "rgba(237, 88, 89, 1)", fontWeight: "bold" }}>
                          Fully Booked
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListCamps;
